if (!customElements.get('jk-quantity-breaks')) {
  customElements.define('jk-quantity-breaks', class extends HTMLElement {
    connectedCallback() {
      this._sectionId   = this.dataset.sectionId;
      this._productInfo = this.closest('product-info');

      // 1. Try Dawn's standard quantity input (present when quantity_selector block is active)
      this._qtyInput = this._productInfo
        ? this._productInfo.querySelector('input.quantity__input')
        : null;

      // 2. Fallback: inject a hidden quantity input directly into the product form.
      //    This is the normal case when quantity_selector block is not in the template,
      //    since jk_quantity_breaks replaces it visually.
      if (!this._qtyInput) {
        const form = this._productInfo
          ? this._productInfo.querySelector('form[data-type="add-to-cart-form"]')
          : document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          let injected = form.querySelector('input[data-jk-qty]');
          if (!injected) {
            injected = document.createElement('input');
            injected.type  = 'hidden';
            injected.name  = 'quantity';
            injected.value = '1';
            injected.dataset.jkQty = 'true';
            form.appendChild(injected);
          }
          this._qtyInput = injected;
        }
      }

      // Tile selection
      this.querySelectorAll('input[type="radio"]').forEach(radio =>
        radio.addEventListener('change', e => this._onTileChange(e))
      );

      // Watch for variant price changes via the selected-variant JSON blob
      // Dawn replaces this script tag's content when a variant is selected
      const variantData = this._productInfo?.querySelector('[data-selected-variant]');
      if (variantData) {
        this._observer = new MutationObserver(() => this._updatePrices());
        this._observer.observe(variantData, { childList: true, subtree: true, characterData: true });
      }

      // Hide the standard qty selector — our tiles replace it visually.
      // The input stays in the DOM so the form can still submit the quantity.
      const qtyForm = this._productInfo?.querySelector('.product-form__quantity');
      if (qtyForm) qtyForm.hidden = true;

      // Sync quantity to the initially checked tile
      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this._applyQuantity(checked.dataset.qty);
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }

    _onTileChange(evt) {
      const radio = evt.target;
      this.querySelectorAll('.jk-qty-breaks__tile').forEach(t =>
        t.classList.toggle('is-active', t === radio.closest('.jk-qty-breaks__tile'))
      );
      this._applyQuantity(radio.dataset.qty);
      this._notifyShipping(radio);
    }

    // Basispreis fuer die Versand-Schwellen-Pruefung: bevorzugt den
    // live aktualisierten Varianten-JSON-Blob (falls ein echter
    // Variantenwechsel stattgefunden hat), sonst den beim Rendern
    // mitgegebenen data-base-price (Normalfall — Produkte mit
    // Mengen-Kacheln haben meist nur eine einzige Variante, kein
    // [data-selected-variant] im DOM, siehe snippets/product-variant-
    // picker.liquid).
    _currentBasePrice() {
      const variantData = this._productInfo?.querySelector('[data-selected-variant]');
      if (variantData) {
        try {
          const variant = JSON.parse(variantData.textContent);
          if (typeof variant?.price === 'number') return variant.price;
        } catch { /* fall through to data-base-price */ }
      }
      const attr = parseInt(this.dataset.basePrice, 10);
      return Number.isNaN(attr) ? null : attr;
    }

    // Meldet den fuer die Gratisversand-Schwelle relevanten Preis der
    // aktuell gewaehlten Kachel an die seitenweite Umschaltung in
    // jk-delivery-promise.js (Entscheid Andreas 28.07.2026). Wird nur
    // aus Event-Handlern aufgerufen (Kachel-Klick, Preis-Neuberechnung
    // nach echtem Variantenwechsel) — nie synchron beim initialen
    // Connect, da defer-Skripte in Dokumentreihenfolge laden und
    // jk-delivery-promise.js hier noch nicht ausgefuehrt sein koennte.
    _notifyShipping(radio) {
      if (typeof window.jkUpdateShippingToggles !== 'function' || !radio) return;
      const basePrice = this._currentBasePrice();
      if (basePrice == null) return;
      const qty      = parseInt(radio.dataset.qty, 10) || 1;
      const discount = parseInt(radio.dataset.discount, 10) || 0;
      const price = Math.round(basePrice * qty * (100 - discount) / 100);
      window.jkUpdateShippingToggles(price);
    }

    _applyQuantity(qty) {
      if (!this._qtyInput) return;
      const min = parseInt(this._qtyInput.min || '1', 10) || 1;
      const n   = Math.max(min, parseInt(qty, 10) || 1);
      this._qtyInput.value = String(n);
      this._qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _updatePrices() {
      // Kachel-Preise entfernt (Entscheid Andreas 18.08.2026): die
      // Kacheln zeigen nur noch Menge + «Spare n%» — der Preisblock
      // oben (jk-product-price.js) ist die einzige Preisquelle.
      // Diese Methode bleibt als Variantenwechsel-Hook fuer die
      // Versand-Schwellen-Pruefung: ein echter Variantenwechsel kann
      // den Basispreis aendern (Entscheid Andreas 28.07.2026), die
      // aktuell gewaehlte Kachel muss mit dem neuen Preis nachziehen.
      const checked = this.querySelector('input[type="radio"]:checked');
      this._notifyShipping(checked);
    }
  });
}
